import Script from 'App/resources/Model/Script';
import logError from 'Helpers/logError';

export const reloadWithDebugInfoIfNeeded = (scripts: Script[]): boolean => {
	const needsDebugInfo = scripts.some(({ active, code }) => active && code?.includes('scope()'));

	try {
		localStorage.setItem('enableDebugInfo', needsDebugInfo ? '1' : '0');
	} catch (error) {
		logError(error, 'Failed to persist enableDebugInfo');
	}

	if (!needsDebugInfo || document.querySelector('.ng-scope')) {
		return false;
	}

	angular.reloadWithDebugInfo();
	return true;
};
